// extracted by mini-css-extract-plugin
export default {"langBtn":"LangBtn_langBtn__iVqxM"};